import { PropsWithChildren, useContext } from "react";
import { Box } from "@mui/material";
import { TabsReactContext } from "src/components-mui/tabs/tabs-context";

interface ITabPanelProps {
    keepMounted?: boolean;
    value?: string | number;
}

export const TabPanel = ({ keepMounted = true, children, value }: PropsWithChildren<ITabPanelProps>) => {
    const context = useContext(TabsReactContext);

    return (
        <Box sx={{ display: context.currentTab == value ? "block" : "none" }}>{context.currentTab === value && (keepMounted ? children : null)}</Box>
    );
};
